module.exports = {
	"config": {
		"siteTitle": "Trimmis",
		"linkPrefix": "/testing/public"
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "",
				"stem": "_template",
				"path": "_template.jsx"
			},
			"requirePath": "_template.jsx",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "404.md",
				"ext": "md",
				"name": "404",
				"extname": ".md",
				"basename": "404.md",
				"dirname": "",
				"stem": "404",
				"path": "404.md"
			},
			"requirePath": "404.md",
			"path": "/404.html",
			"data": {
				"path": "/404.html"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "fi",
				"base": "index.yaml",
				"ext": "yaml",
				"name": "index",
				"extname": ".yaml",
				"basename": "index.yaml",
				"dirname": "fi",
				"stem": "index",
				"path": "fi/index.yaml"
			},
			"requirePath": "fi/index.yaml",
			"path": "/fi/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "fi",
				"base": "varaus.yaml",
				"ext": "yaml",
				"name": "varaus",
				"extname": ".yaml",
				"basename": "varaus.yaml",
				"dirname": "fi",
				"stem": "varaus",
				"path": "fi/varaus.yaml"
			},
			"requirePath": "fi/varaus.yaml",
			"path": "/fi/varaus/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "se",
				"base": "index.yaml",
				"ext": "yaml",
				"name": "index",
				"extname": ".yaml",
				"basename": "index.yaml",
				"dirname": "se",
				"stem": "index",
				"path": "se/index.yaml"
			},
			"requirePath": "se/index.yaml",
			"path": "/se/",
			"data": {}
		}
	]
}


//////////////////
// WEBPACK FOOTER
// ../config.toml
// module id = 384
// module chunks = 0